import * as React from 'react';
import { app, dialog, UrlDialogInfo } from "@microsoft/teams-js";
import { RouteComponentProps } from 'react-router-dom';
import { getMeetingData, getQueueById, endCall, getCurrentUserPhoto, sendMeetingNotification, getQueueAttachments, updateAssuntoAndNotes } from '../../../api/teamsapp-api';
import { getAppSettings } from '../../../api/settings-api';
import { getAppConfig } from '../../../api/publicapp-api';
import { Avatar, Box, Button, Divider, Dropdown, Flex, FlexItem, Image, Loader, Segment, Text, TextArea } from '@fluentui/react-northstar';
import { initializeIcons, Icon } from '@fluentui/react';
import { AcceptIcon, BulletsIcon, CloseIcon, ChevronDownMediumIcon, ChevronStartIcon, ChevronEndIcon, CallIcon, MentionIcon, SpeakerPersonIcon, FilesPdfIcon, WordIcon, ExcelIcon, EditIcon, NotesIcon, FilesPictureColoredIcon } from '@fluentui/react-icons-northstar';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import StatusQueueConstants from "../../../constants/status-queue";
import ImagesBase64 from "../../../constants/images-base64";
import PostMeetingPanel from "../post-meeting-panel/post-meeting-panel";
import './in-meeting-panel.scss';

const moment = require('moment');

export interface IMeetingPanel {
    loading: boolean;
    meetingData: any;
    authEnabled: boolean;
    govBrEnabled: boolean;
    meetingQueueData: any;
    appConfigs: any;
    interval: any | null;
    atendentePhoto: string;
    botInvoked: boolean;
    loadingBot: boolean;
    hasAttachments: boolean;
    attachments: any | null;
    features: string[];
    userQueueAttachmentsSettingsEnabled: boolean;
    userQueueAttachmentsUnitSettingsEnabled: boolean;
    loadingSettings: boolean;
    loadingUnitSettings: boolean;
    loadingEndMeeting: boolean;
    ended: boolean;
    initView: boolean;
    statusView: boolean;
    notesView: boolean;
    attachmentsView: boolean;
    listAssuntos: any;
    selectedTag: string | null;
    notes: string | null;
    loadingTagsNotes: boolean;
    savedInfo: boolean;
}

export interface ITaskInfo {
    action?: string;
    title?: string;
    height?: number;
    width?: number;
    url?: string;
    card?: string;
    fallbackUrl?: string;
    completionBotId?: string;
}

export type IMeetingPanelProps = {} & RouteComponentProps & WithTranslation;

class InMeetingPanel extends React.Component<IMeetingPanelProps, IMeetingPanel> {
    private localize: TFunction;
    queueId?: any = null;
    frameContext?: any = null;
    inMeetingSidePanel: string = "sidePanel";
    postMeetingPanel: string = "content";
    chatId: string = "";

    constructor(props: IMeetingPanelProps) {
        super(props);
        this.localize = this.props.t;
        initializeIcons();

        this.state = {
            appConfigs: null,
            meetingData: {},
            authEnabled: false,
            govBrEnabled: false,
            meetingQueueData: [],
            loading: true,
            interval: null,
            atendentePhoto: "",
            botInvoked: false,
            loadingBot: false,
            hasAttachments: false,
            attachments: null,
            features: [],
            userQueueAttachmentsSettingsEnabled: false,
            userQueueAttachmentsUnitSettingsEnabled: false,
            loadingSettings: true,
            loadingUnitSettings: true,
            loadingEndMeeting: false,
            ended: false,
            initView: true,
            statusView: false,
            notesView: false,
            attachmentsView: false,
            listAssuntos: [],
            selectedTag: null,
            notes: null,
            loadingTagsNotes: false,
            savedInfo: false,
        };
    }

    public componentDidMount() {
        app.initialize();
        app.getContext().then((context: app.Context) => {
            this.chatId = context.chat.id;
            this.frameContext = context.page.frameContext;
            this.queueId = context.page.id;

            this.getAppConfig();
            this.getAppSettings();
            this.getMeetingQueueData(this.queueId);

            if (this.frameContext == this.inMeetingSidePanel) {
                let interval = setInterval(() => this.getMeetingQueueData(this.queueId), 20000);
                this.setState({ interval: interval });
            }
        });
    }

    public componentWillUnmount() {
        clearInterval(this.state.interval);
    }

    /**
     * Get app configs
     * */
    private getAppConfig = async () => {
        const response = await getAppConfig();

        if (response.status === 200 && response.data) {
            this.setState({
                appConfigs: response.data,
            });
        }
    };

    /**
     * Get app settings
     * */
    private getAppSettings = async () => {
        const response = await getAppSettings();

        if (response.status === 200 && response.data) {
            this.setState({
                loadingSettings: false,
                userQueueAttachmentsSettingsEnabled: response.data.userQueueAttachments,
                features: response.data.featuresList,
            })
        }

        this.setState({
            loadingSettings: false,
        })
    }

    /**
      * Get meeting
      * */
    public getMeeting = async (ancora: string) => {
        const response = await getMeetingData(ancora);

        if (response.status === 200 && response.data) {
            this.setState({
                loadingUnitSettings: false,
                meetingData: response.data,
                authEnabled: response.data.authEnabled,
                govBrEnabled: response.data.govBrEnabled,
                userQueueAttachmentsUnitSettingsEnabled: response.data.userQueueAttachments && !response.data.acsEnabled,
                listAssuntos: response.data.assuntos,
            })
        }

        this.setState({
            loadingUnitSettings: false,
        })
    }

    /**
      * Get meeting queue
      * */
    public getMeetingQueueData = async (queueId: string) => {
        const response = await getQueueById(queueId);

        if (response.status === 200 && response.data) {
            await this.getMeeting(response.data.Ancora);

            this.setState({
                loading: false,
                meetingQueueData: response.data,
                selectedTag: this.state.selectedTag ? this.state.selectedTag : response.data.assunto,
                notes: this.state.notes ? this.state.notes : response.data.notes,
            })

            if (response.data.hasAttachments) {
                let attachmentResponse = await getQueueAttachments(response.data.id);

                if (attachmentResponse.status === 200 && attachmentResponse.data) {
                    this.setState({
                        hasAttachments: true,
                        attachments: attachmentResponse.data,
                    })
                }
            }

            if (response.data.status == StatusQueueConstants.atendimentoInativo &&
                this.frameContext == this.inMeetingSidePanel) {
                app.initialize();

                let taskInfo: UrlDialogInfo = {
                    title: this.localize('AtendimentoExpirado'),
                    url: window.location.origin + `/in-meeting-alert?commandContext=task`,
                    size: {
                        height: 150,
                        width: 400,
                    }
                }

                clearInterval(this.state.interval);

                dialog.url.open(taskInfo);

                this.setState({
                    ended: true,
                })
            } else if (response.data.status == StatusQueueConstants.atendimentoEncerrado) {
                clearInterval(this.state.interval);

                this.setState({
                    ended: true,
                })
            }
        }
    }

    public encerrar = () => {
        this.setState({
            loadingEndMeeting: true
        });

        endCall(this.state.meetingQueueData.id, "").then((response: any) => {
            this.getMeetingQueueData(this.queueId).then(() => {
                this.setState({
                    loadingEndMeeting: false,
                    ended: true,
                });
            });
        })
    }

    public statusColor = (status: string) => {
        if (status == StatusQueueConstants.atendimentoIniciado)
            return 'blue';
        else if (status == StatusQueueConstants.emAtendimento)
            return 'green';
        else
            return 'red';
    }

    public getTempoEspera = (history: any) => {
        let itemEmAtendimento = history.find((e: any) => e.status == StatusQueueConstants.emAtendimento);
        let itemNaFila = history.find((e: any) => e.status == StatusQueueConstants.naFila);
        let itemAgendado = history.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado);

        let tempoEsperaMin = moment(moment(itemEmAtendimento?.created).diff(moment(itemNaFila?.created))).format("mm");
        let tempoEsperaSec = moment(moment(itemEmAtendimento?.created).diff(moment(itemNaFila?.created))).format("ss");

        if (itemAgendado) {
            tempoEsperaMin = moment(moment(itemEmAtendimento?.created).diff(moment(itemAgendado?.created))).format("mm");
            tempoEsperaSec = moment(moment(itemEmAtendimento?.created).diff(moment(itemAgendado?.created))).format("ss");
        }

        return [tempoEsperaMin, tempoEsperaSec].join('m') + 's';
    }

    public getLabelStatusLocale = (status?: string) => {
        if (status) {
            if (status == StatusQueueConstants.naFila)
                return this.localize("NaFila")
            else if (status == StatusQueueConstants.atendimentoIniciado)
                return this.localize("AtendimentoIniciado")
            else if (status == StatusQueueConstants.emAtendimento)
                return this.localize("EmAtendimento")
            else if (status == StatusQueueConstants.atendimentoEncerrado)
                return this.localize("AtendimentoEncerrado")
            else if (status == StatusQueueConstants.atendimentoInativo)
                return this.localize("AtendimentoInativo")
            else if (status == StatusQueueConstants.atendimentoCancelado)
                return this.localize("AtendimentoCancelado")
        }
    }

    public setInitView = () => {
        this.setState({
            initView: true,
            statusView: false,
            notesView: false,
            attachmentsView: false,
        })
    }

    public setStatusView = () => {
        this.setState({
            initView: false,
            statusView: true,
        })
    }

    public setNotesView = () => {
        this.setState({
            initView: false,
            notesView: true,
        })
    }

    public setAttachmentsView = () => {
        this.setState({
            initView: false,
            attachmentsView: true,
        })
    }

    public onChangeTag = (event: any, item: any) => {
        this.setState({
            selectedTag: item.value,
        })
    }

    public updateTagsAndNotes = async () => {
        this.setState({
            loadingTagsNotes: true,
        }, async () => {
            const data = {
                assunto: this.state.selectedTag,
                notes: this.state.notes,
            }
            const response = await updateAssuntoAndNotes(this.state.meetingQueueData.id, data);

            if (response.status === 200) {
                this.getMeetingQueueData(this.queueId);

                this.setState({
                    loadingTagsNotes: false,
                    savedInfo: true,
                }, () => {
                    setTimeout(() => this.setState({
                        savedInfo: false,
                    }), 3500)
                })
            }
        })
    }

    public renderFiles = (attachment: any, index: number) => {
        let fileName = attachment.fileName;
        let icon = null;

        if (fileName?.toLowerCase().includes("pdf"))
            icon = <FilesPdfIcon />
        else if (fileName?.toLowerCase().includes("doc"))
            icon = <WordIcon />
        else if (fileName?.toLowerCase().includes("xls"))
            icon = <ExcelIcon />
        else
            icon = <FilesPictureColoredIcon />

        return (
            <Flex gap="gap.medium" column>
                {index > 0 && <Divider />}

                <Flex gap="gap.medium">
                    {icon}
                    <Text
                        as="a"
                        href={attachment.blobUrl}
                        size="small"
                        className="file-link"
                        content={attachment.fileName.split("_")[2]}
                    />
                </Flex>
            </Flex>
        );
    }

    public render() {
        if (this.state.loading || this.state.loadingSettings || this.state.loadingUnitSettings) {
            return (
                <Loader className="loader" />
            );
        } else if (this.frameContext == this.inMeetingSidePanel) {
            const meetingQueueData = this.state.meetingQueueData;

            let prefix = "#";
            let queueId = `${prefix}${meetingQueueData?.id.substr(meetingQueueData?.id.length - 6)}`;

            if (meetingQueueData && meetingQueueData.AdditionalData?.nrProcesso) {
                prefix = "";
                queueId = meetingQueueData.AdditionalData?.nrProcesso;
            }

            return (
                <Flex className="in-meeting-panel" gap="gap.medium" column>
                    {this.state.initView &&
                        <React.Fragment>
                            <Flex className="panel-header" vAlign="center" gap="gap.medium">
                                <FlexItem>
                                    <Image className="logo-img" circular src={ImagesBase64.logo} />
                                </FlexItem>

                                <Flex column>
                                    {!this.state.meetingQueueData.Schedule ?
                                        <FlexItem>
                                            <Text className="title" size="larger" content={`${this.localize("Atendimento")}`} />
                                        </FlexItem>
                                        :
                                        <FlexItem>
                                            <Text className="title" size="larger" content={`${this.localize("Agendamento")}`} />
                                        </FlexItem>
                                    }
                                    
                                    <FlexItem>
                                        <Text className="sub-title" size="larger" content={`${prefix}${queueId}`} />
                                    </FlexItem>
                                </Flex>
                            </Flex>

                            <Divider />

                            <Flex gap="gap.smaller" column>
                                <Flex className={`status-bar-${this.statusColor(this.state.meetingQueueData?.status)}`} gap="gap.smaller" vAlign="center" column>
                                    <Text size="medium" weight="semibold" content={`${this.localize("Status")}: ${this.state.meetingQueueData?.status}`} />
                                    <Text size="small" content={`${this.localize("UltimaAtualizacao")} - ${moment(this.state.meetingQueueData?.updated).format("HH:mm:ss")}`} />
                                </Flex>
                                <Flex vAlign="center" className="status-bar-history" onClick={this.setStatusView}>
                                    <Flex.Item>
                                        <Flex gap="gap.smaller" vAlign="center">
                                            <BulletsIcon size="small" className="button-icon" outline />
                                            <Text color="brand" size="small" content={this.localize("Detalhes")} />
                                        </Flex>
                                    </Flex.Item>
                                    <Flex.Item push>
                                        <ChevronEndIcon size="small" />
                                    </Flex.Item>
                                </Flex>
                            </Flex>

                            <Segment className="panel-content" color="black">
                                <Flex gap="gap.small" column>
                                    <Flex gap="gap.smaller" vAlign="center">
                                        {this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado)?.created ?
                                            <Text className="title-width" size="small" content={this.localize("AgendadoEm")} />
                                            :
                                            <Text className="title-width" size="small" content={this.localize("SolicitadoEm")} />
                                        }

                                        
                                        {this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.naFila)?.created &&
                                            <Text className="content-width" size="small" content={moment(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.naFila).created).format("HH:mm:ss")} />
                                        }
                                        {this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado)?.created &&
                                            <Text className="content-width" size="small" content={moment(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado).created).format("HH:mm:ss")} />
                                        }
                                    </Flex>

                                    {(this.state.meetingQueueData?.Schedule?.date && this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado)?.created) &&
                                        <React.Fragment>
                                            <Divider />
                                            <Flex gap="gap.smaller" vAlign="center">
                                                <Text className="title-width" size="small" content={this.localize("DataAgendamentoLabel")} />
                                                <Text className="content-width" size="small" content={moment(this.state.meetingQueueData?.Schedule.date).format("DD/MM HH:mm")} />
                                            </Flex>
                                        </React.Fragment> 
                                    }

                                    {(this.state.meetingQueueData?.status == StatusQueueConstants.emAtendimento ||
                                        this.state.meetingQueueData?.status == StatusQueueConstants.atendimentoEncerrado) &&
                                        <React.Fragment>
                                            <Divider />

                                            <Flex gap="gap.smaller" vAlign="center">
                                                <Text className="title-width" size="small" content={this.localize("TempoEspera")} />
                                                <Text className="content-width" size="small" content={this.getTempoEspera(this.state.meetingQueueData?.History)} />
                                            </Flex>
                                        </React.Fragment>
                                    }

                                    {this.state.meetingQueueData?.status == StatusQueueConstants.atendimentoEncerrado &&
                                        <React.Fragment>
                                            <Divider />

                                            <Flex gap="gap.smaller" vAlign="center">
                                                <Text className="title-width" size="small" content={this.localize("EncerradoEm")} />
                                                <Text
                                                    className="content-width"
                                                    size="small"
                                                    content={moment(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoEncerrado).created).format("HH:mm:ss")}
                                                />

                                            </Flex>
                                        </React.Fragment>
                                    }

                                    {this.state.meetingQueueData?.assunto &&
                                        <React.Fragment>
                                            <Divider />

                                            <Flex gap="gap.smaller" vAlign="center">
                                                <Text className="title-width" size="small" content={this.localize("Assunto")} />
                                                <Text className="content-width" size="small" content={this.state.meetingQueueData?.assunto} />
                                            </Flex>
                                        </React.Fragment>
                                    }
                                </Flex>
                            </Segment>

                            <Flex gap="gap.smaller" column>
                                <Flex vAlign="center" className="notes-info" column>
                                    <Text size="small" content={this.localize("ReclassificarAtendimento")} />
                                </Flex>

                                <Flex vAlign="center" className="notes" onClick={this.setNotesView}>
                                    <Flex.Item>
                                        <Flex gap="gap.smaller" vAlign="center">
                                            <EditIcon className="button-icon" size="small" outline />
                                            <Text color="brand" size="small" content={this.localize("Anotacoes")} />
                                        </Flex>
                                    </Flex.Item>
                                    <Flex.Item push>
                                        <ChevronEndIcon size="small" />
                                    </Flex.Item>
                                </Flex>
                            </Flex>


                            {(this.state.userQueueAttachmentsSettingsEnabled &&
                                this.state.userQueueAttachmentsUnitSettingsEnabled) &&
                                <Flex gap="gap.smaller" column>
                                    <Flex vAlign="center" className="notes-info" column>
                                        <Text size="small" content={this.localize("TransferenciaArquivos")} />
                                    </Flex>

                                    <Flex vAlign="center" className="files" onClick={this.setAttachmentsView}>
                                        <Flex.Item>
                                            <Flex gap="gap.smaller" vAlign="center" styles={{ width: "100%" }}>
                                                <NotesIcon className="button-icon" size="small" outline />
                                                <Text color="brand" size="small" content={this.localize("Arquivos")} />
                                                {this.state.hasAttachments &&
                                                    <Text content={(this.state.attachments.length)} className="files-number" size="smaller" />
                                                }
                                            </Flex>
                                        </Flex.Item>
                                        <Flex.Item push>
                                            <ChevronEndIcon size="small" />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            }

                            <Button
                                className={this.state.loadingEndMeeting ? "readonly ext-button" : "ext-button"}
                                primary
                                onClick={this.encerrar}
                                loading={this.state.loadingEndMeeting}
                                disabled={this.state.ended}
                                content={this.state.ended ? this.localize("AtendimentoEncerrado") : this.localize("Encerrar")}
                            />
                        </React.Fragment>
                    }

                    {this.state.statusView &&
                        <React.Fragment>
                            <Flex className="breadcrumb" vAlign="center" gap="gap.smaller" onClick={this.setInitView}>
                                <ChevronStartIcon />
                                <Text className="title" size="large" content={this.localize("Detalhes")} />
                            </Flex>

                            <Divider />

                            {(this.state.authEnabled && this.state.govBrEnabled) &&
                                <React.Fragment>
                                    <Flex className="details" gap="gap.small" vAlign="center">
                                        <Text weight="semibold" size="small" content={this.localize("Solicitante")} />
                                        <ChevronDownMediumIcon />

                                        <FlexItem align="end" push>
                                            <Image width="45" src="https://studio365cdn.azureedge.net/balcaovirtual/gov-br.svg" />
                                        </FlexItem>
                                    </Flex>

                                    <Segment className="panel-content" color="black">
                                        <Flex gap="gap.medium" column>
                                            <Flex gap="gap.medium" vAlign="center" column>
                                                <Flex gap="gap.medium" vAlign="center">
                                                    {this.state.meetingQueueData?.UserProfile?.userPhoto &&
                                                        <Avatar
                                                            image={`data:image/jpeg;base64,${this.state.meetingQueueData?.UserProfile?.userPhoto}`}
                                                            size="larger"
                                                        />
                                                    }
                                                    <Flex hAlign="start" gap="gap.smaller" column>
                                                        <Text weight="semibold" content={this.state.meetingQueueData?.UserProfile?.userName} />

                                                        <Flex vAlign="center" gap="gap.smaller">
                                                            <SpeakerPersonIcon size="smaller" outline />
                                                            <Text weight="light" size="smaller" content={this.state.meetingQueueData?.UserProfile?.userLogin} />
                                                        </Flex>
                                                        <Flex vAlign="center" gap="gap.smaller">
                                                            <MentionIcon size="smaller" outline />
                                                            <Text weight="light" size="smaller" content={this.state.meetingQueueData?.UserProfile?.email} />
                                                        </Flex>
                                                        <Flex vAlign="center" gap="gap.smaller">
                                                            <CallIcon size="smaller" outline />
                                                            <Text weight="light" size="smaller" content={this.state.meetingQueueData?.UserProfile?.phoneNumber} />
                                                        </Flex>

                                                    </Flex>
                                                </Flex>
                                            </Flex>
                                        </Flex>
                                    </Segment>
                                </React.Fragment>
                            }

                            <Segment className="panel-content details" color="black">
                                <Flex className="status-box">
                                    <Flex className="status-space">
                                    </Flex>
                                    <Flex className="status-details">
                                        <FlexItem>
                                            <Box className={(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado)?.created ||
                                                this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.naFila)?.created) ? "status-icon-active" : "status-icon"}>
                                                <AcceptIcon size="smallest" />
                                            </Box>
                                        </FlexItem>
                                        <Flex column className="status-info">
                                            <FlexItem>
                                                {this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado)?.created ?
                                                    <Text content={this.localize("Agendado")} />
                                                    :
                                                    <Text content={this.localize("NaFila")} />
                                                }
                                            </FlexItem>
                                            <FlexItem>
                                                <Flex className="status-time" gap="gap.smaller">
                                                    <Icon className="margin-style clock-icon" iconName="Clock" />
                                                    {this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.naFila)?.created &&
                                                        <Text size="small" content={moment(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.naFila).created).format("HH:mm:ss")} />
                                                    }

                                                    {this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado)?.created &&
                                                        <Text size="small" content={moment(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado).created).format("HH:mm:ss")} />
                                                    }
                                                </Flex>
                                            </FlexItem>
                                        </Flex>
                                    </Flex>
                                </Flex>

                                <Flex className="status-box">
                                    <Flex className="status-space">
                                    </Flex>
                                    <Flex className="status-details">
                                        <FlexItem>
                                            <Box className={this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoIniciado)?.created ? "status-icon-active" : "status-icon"}>
                                                <AcceptIcon size="smallest" />
                                            </Box>
                                        </FlexItem>
                                        <Flex column className="status-info">
                                            <FlexItem>
                                                <Text content={this.localize("AtendimentoIniciado")} />
                                            </FlexItem>
                                            <FlexItem>
                                                <Flex className="status-time" gap="gap.smaller">
                                                    <Icon className="margin-style clock-icon" iconName="Clock" />
                                                    <Text size="small" content={moment(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoIniciado).created).format("HH:mm:ss")} />
                                                </Flex>
                                            </FlexItem>
                                        </Flex>
                                    </Flex>
                                </Flex>

                                <Flex className="status-box">
                                    <Flex className="status-space">
                                    </Flex>
                                    <Flex className="status-details" >
                                        <FlexItem>
                                            <Box className={(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.emAtendimento)?.created ||
                                                this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoInativo)?.created) ? "status-icon-active" : "status-icon"}>
                                                <AcceptIcon size="smallest" />
                                            </Box>
                                        </FlexItem>

                                        <Flex column className="status-info">
                                            <FlexItem>
                                                <Text content={this.localize("EmAtendimento")} />
                                            </FlexItem>

                                            {(this.state.meetingQueueData?.status == StatusQueueConstants.emAtendimento ||
                                                this.state.meetingQueueData?.status == StatusQueueConstants.atendimentoEncerrado) &&
                                                <FlexItem>
                                                    <Flex className="status-time" gap="gap.smaller">
                                                        <Icon className="margin-style clock-icon" iconName="Clock" />
                                                        <Text size="small" content={moment(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.emAtendimento)?.created).format("HH:mm:ss")} />
                                                    </Flex>
                                                </FlexItem>
                                            }

                                        </Flex>
                                    </Flex>
                                </Flex>

                                <Flex className="status-box">
                                    <Flex className="status-space">
                                    </Flex>
                                    <Flex className="status-details status-details-last">
                                        <FlexItem>
                                            <Box className={(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoEncerrado)?.created ||
                                                this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoInativo)?.created) ? "status-icon-active" : "status-icon"}>
                                                <AcceptIcon size="smallest" />
                                            </Box>
                                        </FlexItem>
                                        <Flex column className="status-info">
                                            {this.state.meetingQueueData?.status != StatusQueueConstants.atendimentoInativo ?
                                                <React.Fragment>
                                                    <FlexItem>
                                                        <Text content={this.localize("AtendimentoEncerrado")} />
                                                    </FlexItem>

                                                    {this.state.meetingQueueData?.status == StatusQueueConstants.atendimentoEncerrado &&
                                                        <FlexItem>
                                                            <Flex className="status-time" gap="gap.smaller">
                                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                                <Text size="small" content={moment(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoEncerrado).created).format("HH:mm:ss")} />
                                                            </Flex>
                                                        </FlexItem>
                                                    }
                                                </React.Fragment>

                                                :
                                                <React.Fragment>
                                                    <FlexItem>
                                                        <Text content={this.localize("AtendimentoInativo")} />
                                                    </FlexItem>

                                                    <FlexItem>
                                                        <Flex className="status-time" gap="gap.smaller">
                                                            <Icon className="margin-style clock-icon" iconName="Clock" />
                                                            <Text size="small" content={moment(this.state.meetingQueueData?.History.find((e: any) => e.status == StatusQueueConstants.atendimentoInativo).created).format("HH:mm:ss")} />
                                                        </Flex>
                                                    </FlexItem>
                                                </React.Fragment>
                                            }
                                        </Flex>
                                    </Flex>
                                </Flex>
                            </Segment>
                        </React.Fragment>
                    }

                    {this.state.notesView &&
                        <React.Fragment>
                            <Flex className="breadcrumb" vAlign="center" gap="gap.smaller" onClick={this.setInitView}>
                                <ChevronStartIcon />
                                <Text className="title" size="large" content={this.localize("Anotacoes")} />
                            </Flex>

                            <Divider />

                            <Flex className="notes-box" gap="gap.medium" column>
                                <Text className="label-field" size="small" content={this.localize("ReclassificarAssunto")} />
                                <Dropdown
                                    items={this.state.listAssuntos}
                                    placeholder={this.localize("Selecione")}
                                    checkable
                                    inverted
                                    onChange={this.onChangeTag}
                                    value={this.state.selectedTag}
                                />

                                <Divider />

                                <Text className="label-field" size="small" content={this.localize("Notas")} />
                                <TextArea
                                    inverted
                                    maxLength={255}
                                    onChange={(e: any) => this.setState({ notes: e.target.value })}
                                    value={this.state.notes!}
                                />

                                <Button
                                    className={(this.state.loadingTagsNotes || this.state.savedInfo) ? "readonly notes-btn" : "notes-btn"}
                                    content={this.state.savedInfo ? this.localize("InformacoesSalvas") : this.localize("Salvar")}
                                    icon={this.state.savedInfo ? <AcceptIcon /> : null}
                                    onClick={this.updateTagsAndNotes}
                                    loading={this.state.loadingTagsNotes}
                                />
                            </Flex>
                        </React.Fragment>
                    }
                </Flex>
            );
        } else {
            return (
                <PostMeetingPanel
                    queueId={this.queueId}
                    meetingQueueData={this.state.meetingQueueData}
                    atendentePhoto={this.state.atendentePhoto}
                />
            );
        }
    }
}

const inMeetingPanelWithTranslation = withTranslation()(InMeetingPanel);
export default inMeetingPanelWithTranslation;
